import { isVideoCaptureEnabled } from '../../../util/userUtil';
import { sessionUserSelector } from './sessionUserSelector';

import { createSelector } from 'reselect';

const isVideoCaptureEnabledSelector = createSelector(sessionUserSelector, ({ sessionUser }) => ({
  isVideoCaptureEnabled: isVideoCaptureEnabled(sessionUser)
}));
export { isVideoCaptureEnabledSelector };
